import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import type { EntityPickerOptions } from '@adornis/entity-picker/client/entity-picker-options.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { html } from 'lit';
import { ChancenwerkUserFilter } from '../../../../filter/ChancenwerkUserFilter.js';
import { UserAPI } from '../../api/UserAPI.js';
import { ChancenwerkUser } from '../ChancenwerkUser.js';

@Entity()
export class ChancenwerkUserAspect extends AbstractAspect {
  static override _class = 'ChancenwerkUserAspect';

  constructor(doc: PartialEntityData<ChancenwerkUserAspect>) {
    super(doc);
  }

  @Field(() => [ID]) value: Maybe<string[]>;
  @Field(() => [String]) name: Maybe<string[]>;

  override getMongoFilter(): object | null {
    if (!this.fieldName || !this.value?.length) return null;

    return {
      [this.fieldName]: { $in: this.value },
    };
  }
}

export const ChancenwerkUserAspectSchema: (filter?: ChancenwerkUserFilter) => AspectConfig<ChancenwerkUserAspect> = (
  filter: ChancenwerkUserFilter = new ChancenwerkUserFilter({}),
) => ({
  aspectConstructor: ChancenwerkUserAspect,
  renderEditor: ({ aspectValue }) => html`
    <x-multi-entity-picker
      placeholder-mode="hide"
      clearable
      placeholder="Person"
      .options=${{
        class: ChancenwerkUser,
        operation: UserAPI.subscribeByFilter,
        selectionSet: { vorname: 1, nachname: 1, email: 1 },
        filter: filter ?? new ChancenwerkUserFilter({}),
      } satisfies EntityPickerOptions<typeof ChancenwerkUser>}
      @value-picked=${(e: ValueEvent<Maybe<string[]>>) => {
        aspectValue.value = e.detail.value ?? [];
      }}
      @entity-picked=${(e: ValueEvent<Maybe<ChancenwerkUser[]>>) => {
        aspectValue.name = e.detail.value?.map(p => p.toString() ?? '') ?? [];
      }}
    ></x-multi-entity-picker>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.name ? html` ${aspectValue.name} ` : null),
});
